import { UserRolesEnum } from '@features/auth/enums';

export const checkIsUserAdmin = (user) => user?.role === UserRolesEnum.SUPER_ADMIN;
